<template>
  <li class="menu-item">
    <router-link :class="linkClass" :to="linkTarget">
      <Icon :icon="icon" />
      <span>{{ name }}</span>
    </router-link>
  </li>
</template>

<script>
export default {
  name: "MenuItem",
  props: {
    name: String,
    target: String,
    icon: String,
    status: {
      type: String,
      default: "default"
    }
  },
  computed: {
    linkClass() {
      const styles = ["f-row", "list-link"];
      switch (this.status) {
        case "default":
          return styles;
        case "disabled":
          styles.push("status-disable");
          return styles;
        default:
          return styles;
      }
    },
    linkTarget() {
      if (this.status === "disabled") return "#";
      return this.target;
    }
  }
};
</script>

<style scoped>
.menu-item {
}

.list-link {
  align-items: center;
  margin: 4px 0 4px 16px;
  padding: 4px 8px;
  line-height: 2;
  color: #ddd;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.list-link:hover {
  background: #3c4c5c;
}

.list-link > svg {
  margin-right: 10px;
  font-size: 16px;
}

.list-link > span {
  margin-top: 1px;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 600;
}

.status-disable:hover {
  cursor: default;
  background: none;
}

.status-disable > svg {
  color: #4f5f6f;
}

.status-disable > span {
  color: #4e5e6e;
}
</style>